import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import './assets/tailwind.css'
import './assets/font.css'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')